import type { HomeNavItem } from "./model";

export type ScreenId = HomeNavItem["id"];

export interface ScreenDefinition {
  id: ScreenId;
  label: string;
  purpose: string;
}

export const SCREEN_REGISTRY: Readonly<Record<ScreenId, ScreenDefinition>> = Object.freeze({
  home: {
    id: "home",
    label: "خانه",
    purpose: "نمای کلی سالن، هشدارها و دسترسی سریع",
  },
  today: {
    id: "today",
    label: "کار امروز",
    purpose: "صف کارهای واقعی امروز با وضعیت تأخیر و تعارض",
  },
  "hall-menu": {
    id: "hall-menu",
    label: "منوی سالن",
    purpose: "دسترسی همیشگی به عملیات سالن و ابزارهای مدیریتی",
  },
  patrol: {
    id: "patrol",
    label: "گشت سالن",
    purpose: "اسکن QR و عملیات وابسته به وضعیت تانک",
  },
  feeding: {
    id: "feeding",
    label: "تغذیه",
    purpose: "ثبت نوبت جاری و غذادهی‌های با تأخیر",
  },
  offline: {
    id: "offline",
    label: "آفلاین",
    purpose: "وضعیت صف محلی، ارسال مجدد و تعارض‌های همگام‌سازی",
  },
  workers: {
    id: "workers",
    label: "مدیریت کارگران",
    purpose: "دعوت، عضویت، وضعیت و کارگر فعال شیفت",
  },
  finance: {
    id: "finance",
    label: "حساب‌وکتاب",
    purpose: "ثبت فروش و هزینه، پرداخت‌ها، طرف حساب‌ها و دارایی‌های سالن",
  },
  subscribers: {
    id: "subscribers",
    label: "مدیریت مشترکین",
    purpose: "ایجاد مشترک، صدور کد راه‌اندازی و مدیریت چرخه اشتراک",
  },
  reports: {
    id: "reports",
    label: "گزارش",
    purpose: "گزارش‌های مدیریتی مبتنی بر داده‌های canonical",
  },
  settings: {
    id: "settings",
    label: "تنظیمات",
    purpose: "تنظیمات سالن، دسترسی‌ها، سیاست‌ها و هوش مصنوعی",
  },
});

export function screenDefinition(screenId: ScreenId): ScreenDefinition {
  return SCREEN_REGISTRY[screenId];
}
